export class nullBrowserHistory
{
    push(url, state) {}
    replace(url, state) {}
    listen(dispatchAction) {}
}
